import { memo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectPartnersRegistrationState, selectIsValid } from '@store/partners-registration/selectors';
import { setShowInvalids, resetStore } from '@store/partners-registration/slice';
import { Button } from 'react-aria-components';
import { useSavePartnerRequestMutation } from '@api/baseApi';
import { convertToPartnerRequestDef } from '@store/partners-registration/convertors';
import { NavigateRoutes } from '@features/routing/routesObject';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



interface SaveButtonProps {
	scrollToTop: () => void
}


const SaveButton = (props: SaveButtonProps) => {
	const { scrollToTop } = props;
	const { t } = useTranslation([ 'forms', 'global' ]);
	
	const partnersRegistrationState = useSelector(selectPartnersRegistrationState);
	const isValid = useSelector(selectIsValid);
	const navigate = useNavigate();
	
	const dispatch = useDispatch();
	const showInvalids = (show: boolean) => dispatch(setShowInvalids(show));
	const runResetStore = () => dispatch(resetStore());
	const [ savePartnerRequest, { isError, isLoading, isSuccess } ] = useSavePartnerRequestMutation();


	const handleSave = useCallback(() => {
		if (!isValid || !partnersRegistrationState) {
			showInvalids(true);
			setTimeout(() => scrollToTop(), 5);
			return;
		}
		
		let convertedObject = convertToPartnerRequestDef(partnersRegistrationState);
		if (!convertedObject) return;
		
		savePartnerRequest(convertedObject);
	},[ isValid, partnersRegistrationState ]);


	useEffect(() => {
		if (isSuccess) {
			navigate(NavigateRoutes.thankYouRegistration);
			runResetStore();
		}
	}, [ isSuccess ]);


	if (isError) return (
		<p className='error-message'>{t('postErrorMessage', { ns: 'global' })}</p>
	)


	return (
		<Button className='app-form-button disable-selection' autoFocus={false} isDisabled={isLoading} onPress={handleSave}>
			{isLoading ? <LoadingSpinner /> : t('footer.sendForm')}
		</Button>
	);
};

export default memo(SaveButton);